import {
  FetchResult,
  gql,
  MutationFunctionOptions,
  MutationHookOptions,
  MutationResult,
  TypedDocumentNode,
  useMutation,
} from '@apollo/client';
import {
  SetSalesPartnerConfiguredMutation,
  SetSalesPartnerConfiguredMutationVariables,
  SetSalesPartnersAsConfiguredMutation,
  SetSalesPartnersAsConfiguredMutationVariables,
} from '../../generated/graphql';

const salesPartnerConfiguredMutation: TypedDocumentNode<
  SetSalesPartnerConfiguredMutation,
  SetSalesPartnerConfiguredMutationVariables
> = gql`
  mutation SetSalesPartnerConfigured {
    setSalesPartnerConfigured {
      id
      isConfigured
    }
  }
`;

const salesPartnerAsConfiguredMutation: TypedDocumentNode<
  SetSalesPartnersAsConfiguredMutation,
  SetSalesPartnersAsConfiguredMutationVariables
> = gql`
  mutation SetSalesPartnersAsConfigured($contractPartnerNumbers: [Int!]!) {
    setSalesPartnersAsConfigured(contractPartnerNumbers: $contractPartnerNumbers) {
      id
      name
      permissions {
        id
        permissionId
        granted
      }
      assignedMarketLocations {
        id
        name
        externalName
      }
      contractPartnerNumber
      isConfigured
    }
  }
`;

export function useSalesPartnerConfiguredMutation(
  options?: MutationHookOptions<SetSalesPartnerConfiguredMutation, SetSalesPartnerConfiguredMutationVariables>,
): [
  (
    options?: MutationFunctionOptions<SetSalesPartnerConfiguredMutation, SetSalesPartnerConfiguredMutationVariables>,
  ) => Promise<FetchResult<SetSalesPartnerConfiguredMutation>>,
  MutationResult<SetSalesPartnerConfiguredMutation>,
] {
  return useMutation<SetSalesPartnerConfiguredMutation, SetSalesPartnerConfiguredMutationVariables>(
    salesPartnerConfiguredMutation,
    options,
  );
}

export function useSalesPartnersAsConfiguredMutation(
  contractPartnerNumbers: Array<number>,
  options?: MutationHookOptions<SetSalesPartnersAsConfiguredMutation, SetSalesPartnersAsConfiguredMutationVariables>,
): [
  (
    options?: MutationFunctionOptions<
      SetSalesPartnersAsConfiguredMutation,
      SetSalesPartnersAsConfiguredMutationVariables
    >,
  ) => Promise<FetchResult<SetSalesPartnersAsConfiguredMutation>>,
  MutationResult<SetSalesPartnersAsConfiguredMutation>,
] {
  return useMutation<SetSalesPartnersAsConfiguredMutation, SetSalesPartnersAsConfiguredMutationVariables>(
    salesPartnerAsConfiguredMutation,
    { ...options, variables: { contractPartnerNumbers } },
  );
}
